import { useContext, useEffect, useRef, useState } from "react";
import "../../styles/NavigationBar.css";
import { AppContext } from "../AppProvider";
import { useNavigate } from "react-router-dom";
import GetUserAuthorityService from "../../services/GetUserAuthorityService";
function UserRoleDisplay(userAuthority){
    switch(userAuthority){
        case 'ROOT': return 'Root';
        case 'SYSTEM_ADMIN': return 'System administrator';
        case 'TENANT_ADMIN': return 'Tenant administrator';
        case 'CUSTOMER_ADMIN': return 'Customer administrator';
        case 'CUSTOMER_USER': return 'Customer';
        default: return 'USER';
    }
};
function LogoutAndAccountComponent({showLogoutAndAccountComponent,setShowLogoutAndAccountComponent,}){
    const { user,userProfile,customerIotProfile,logout } = useContext(AppContext);
    const navigate = useNavigate();
    if(!showLogoutAndAccountComponent) return null;
    return(
        <div className="logout-and-account-div">
            <button id="account-button" onClick={() => {
                const userAuthority = GetUserAuthorityService(user?.access_token,customerIotProfile);
                if( userAuthority === 'ROOT');
                else if( userAuthority === 'SYSTEM_ADMIN') navigate(`/system-admin/accounts`);
                else if( userAuthority === 'TENANT_ADMIN') navigate(`/tenants/accounts`);
                else if( userAuthority === 'CUSTOMER_ADMIN') navigate(`/customers/admin/accounts`);
                else if( userAuthority === 'CUSTOMER_USER') navigate(`/customers/user/accounts`);
                setShowLogoutAndAccountComponent(false);
            }}>Account</button>
            <button onClick={() => {
                logout();
            }} id="logout-button">Logout</button>
        </div>
    );
}
const NavigationBar = () => {
    const {user,customerIotProfile,userProfile} = useContext(AppContext);
    const {showSideBar,setShowSideBar} = useContext(AppContext);
    const {mobileSideBarLauncherRef} = useContext(AppContext);
    const {setSelectedComponent} = useContext(AppContext);
    const {showLogoutAndAccountComponent,setShowLogoutAndAccountComponent} = useContext(AppContext);
    const {logout} = useContext(AppContext);
    const {setShowBottomRightMessageBox} = useContext(AppContext);
    const {setBottomRightMessageBoxMessage} = useContext(AppContext);
    const componentRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current && !componentRef.current.contains(event.target) && !event.target.closest('.mobile-accounts-launcher')) {
                setShowLogoutAndAccountComponent(false);
            }
        };
        window.addEventListener('click', handleClickOutside);
        return () => {
            window.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return(
        <div className="navigation-bar">
            <nav>
                <div className="nav-header-container">
                    <div className="mobile-side-bar-launcher"
                        ref={mobileSideBarLauncherRef}>
                        <div onClick={() => {
                            setShowSideBar(!showSideBar);
                        }}>
                            <p></p>
                            <p></p>
                            <p></p>
                        </div>
                    </div>
                    <img className="blink-logo"
                        src={process.env.PUBLIC_URL + '/images/blink-electrics-logo.jpg'}
                        alt="Blink logo"
                        onClick={() => window.location.href="https://blinkelectrics.co.ke/"}
                    />
                    <div className="application-title-container">
                        <p>IOT Portal</p>
                    </div>
                </div>
                <div className="user-and-notification-container">
                    <div className="notifications-container">
                        <img
                            className="notification-icon"
                            src={process.env.PUBLIC_URL + '/images/notification-icon.png'}
                            alt="User profile picture"
                        />
                        <div className="notification-badge">5</div>
                    </div>
                    <div className="user-container" ref={componentRef}>
                        <img
                            className="user-profile-picture"
                            src={process.env.PUBLIC_URL + '/images/user-icon.jpg'}
                            alt="User profile picture"
                        />
                        <div className="user-account-details-container" onClick={() => setShowLogoutAndAccountComponent(prev => !prev)}>
                            <p>{userProfile?.emailAddress}</p>
                            <p>{UserRoleDisplay(GetUserAuthorityService(user?.access_token,customerIotProfile))}</p>
                        </div>
                        {<LogoutAndAccountComponent
                            user={user}
                            userProfile={userProfile}
                            setShowLogoutAndAccountComponent={setShowLogoutAndAccountComponent}
                            showLogoutAndAccountComponent={showLogoutAndAccountComponent}
                            setSelectedComponent={setSelectedComponent}
                            logout={logout}
                            iotRole={GetUserAuthorityService(user?.access_token)}
                            setShowBottomRightMessageBox={setShowBottomRightMessageBox}
                            setBottomRightMessageBoxMessage={setBottomRightMessageBoxMessage}
                        />}
                    </div>
                </div>
                <div className="mobile-accounts-launcher" onClick={() => setShowLogoutAndAccountComponent(prev => !prev)}>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </nav>
        </div>
    );
}
export default NavigationBar;